import { Component } from './Component'

export const Container = () => (
  <Component name="David" logo="path" chatLink={process.env.REACT_APP_CHAT!} />
)
